import React from 'react';
import PetsyPrice from '../PetsyPrice';
import {
  Icon,
  IconColorStyle,
  IconSize,
  useFlowController,
  useFlowData,
  FlowTypes,
} from '@adaptis/flow-components';
import { getTotalPrice, updateTotalAmounts } from '../../util/data-store';
import SaveQuote from '../SaveQuote';
import { ISelectedCoverSummaryProps } from './SelectedCoverSummary.types';
import { PetType } from '../../util/common-types';

import './SelectedCoverSummary.scss';

function PetHead(props: { name: string; type: PetType }) {
  return (
    <div className='pet-head-container'>
      <div className='pet-head'>
        <Icon
          className='icon'
          src={`/images/${props.type}-with-helmet.svg`}
          colorStyle={IconColorStyle.Custom}
          size={IconSize.Custom}
        />
      </div>
      <div className='pet-name'>{props.name}</div>
    </div>
  );
}

export default function SelectedCoverSummary(
  props: ISelectedCoverSummaryProps
) {
  const { getData } = useFlowData();
  const pets = getData('pets');
  const totalPrice = getTotalPrice();

  return (
    <div
      data-testid='SelectedCoverSummary'
      className='flc_selected-cover-summary'>
      <SaveQuote stepSlug='' className='mb-2' />

      <h2>Pet Insurance for:</h2>
      <div className='pet-heads'>
        {pets &&
          pets.map((pet: any, index: number) => {
            return (
              <PetHead
                key={'pet-head' + index}
                name={pet.name}
                type={pet.petType}
              />
            );
          })}
      </div>
      <div className='dashedline'>
        <svg
          width='100%'
          height='20'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'>
          <line x1='0' y1='1' x2='600' y2='1'></line>
        </svg>
      </div>
      <PetsyPrice
        className=''
        price={totalPrice.installmentAmount}
        wasPrice={
          totalPrice.totalInstallmentBeforeDiscount >
          totalPrice.installmentAmount
            ? totalPrice.totalInstallmentBeforeDiscount
            : undefined
        }
        isLoading={false}
      />
      <div className='premium-frequency'>per month</div>
      <div className='tickMessages'>
        {props.tickMessages &&
          props.tickMessages.map((tickMessage, index) => {
            return (
              <div key={'tick-messge' + index}>
                <Icon
                  className='icon'
                  src='/images/icons/check.svg' //{props.image ?? ''}
                  colorStyle={IconColorStyle.Heading}
                  size={IconSize.Medium}
                />
                <span>{tickMessage}</span>
              </div>
            );
          })}
      </div>
    </div>
  );
}
